import { API } from "@/lib/api";

const authed = (url, opts = {}) => fetch(url, { credentials: "include", ...opts });

export async function uploadVideoInChunks(file, caption, onProgress) {
  const startRes = await authed(`${API}/owner/videos/upload/start`, { method: "POST" });
  if (!startRes.ok) throw new Error("start");
  const { upload_id, chunk_size } = await startRes.json();
  const total = Math.ceil(file.size / chunk_size);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunk_size, Math.min(file.size, (i + 1) * chunk_size));
    const res = await authed(`${API}/owner/videos/upload/${upload_id}/chunk?index=${i}`, {
      method: "POST",
      headers: { "Content-Type": "application/octet-stream" },
      body: blob,
    });
    if (!res.ok) throw new Error("chunk");
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const finish = await authed(`${API}/owner/videos/upload/${upload_id}/finish`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ filename: file.name, total_chunks: total, caption }),
  });
  if (!finish.ok) {
    const err = await finish.json().catch(() => ({}));
    throw new Error(err.detail || "finish");
  }
  return finish.json();
}
